import * as React from "react";
import * as classNames from "classnames";
import { Creatable, default as ReactSelectClass } from "react-select";
import { IBaseFormInputProps } from '../';
import { FontAwesomeIcons, FontAwesomeIcon } from "../../../../constants/fontAwesomeIcons";
import './SuggestionFormInput.scss';
import { IOptionConfig } from '../../../../interfaces/forms/IOptionConfig';
import { default as ReactAutocomplete } from "react-autocomplete";


export interface ISuggestionFormInputProps { 
    maxLength?: number; mapProps
    autoFocus?: boolean;
    type?: string;
    placeholder?: string;
    onKeyDown?: (event: React.KeyboardEvent<any>) => void;
    addOnLeft?: React.ReactNode;
    addOnRight?: React.ReactNode;
    addOnRightButton?: React.ReactNode;
    feedbackIcon?: string;
    options: any[];
}

class SuggestionFormInput extends React.Component<ISuggestionFormInputProps & IBaseFormInputProps, any> {
    render() {
        const {
            className,
            addOnLeft,
            addOnRight,
            addOnRightButton,
            autoFocus,
            disabled,
            focused,
            id,
            invalid,
            label,
            name,
            onBlur,
            onChange,
            onFocus,
            onKeyDown,
            onKeyPress,
            type,
            valid,
            value,
            maxLength,
            placeholder,
            feedbackIcon,
            hasSoftError,
            hasHardError,
            options
        } = this.props;

        const derivedClass = className ? className : "form-control";
        const derivedAddonClass = addOnLeft || addOnRight || addOnRightButton ? "input-group" : "";
        
        const textInput = <ReactAutocomplete
            items={options ?? []}
            wrapperStyle={{
                display: 'block',
                position: 'relative'
            }}
            menuStyle={{ 
                position: 'absolute',
                display: 'block',
                borderRadius: '3px',
                top: 36,
                boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                background: 'rgb(255, 255, 255)',
                padding: '0', 
                left: 0,
                overflow: 'auto',
                maxHeight: '50vh', 
                zIndex: 231312312
            }}
            shouldItemRender={(item, value) => !value || item.label.toLowerCase().indexOf(value.toLowerCase()) > -1}
            getItemValue={item => item.label}
            inputProps={{
                
                className: classNames(
                    derivedClass,
                    { "is-invalid": invalid && !disabled },
                    { "rounded-right": invalid && !addOnRight },
                    { "is-warning": hasSoftError && !disabled && (!invalid)}),
                name: name,
                onBlur: onBlur,
                onFocus: onFocus,
                onKeyDown: onKeyDown,
                placeholder: placeholder,
                maxLength: maxLength,
                disabled: disabled
            }}
            renderItem={(item, highlighted) =>
                <div
                    key={item.id}
                    style={{ backgroundColor: highlighted ? '#eee' : 'transparent'}}
                    className="list-group-item"
                >
                    {item.label}
                </div>
            }
            value={value ?? ''}
            onChange={e => onChange(e.target.value)}
            onSelect={value => onChange(value)}
        />
        const hardFeedback = hasHardError && !disabled ?
            <span className={classNames("form-control-feedback block pr-2")}>
                <FontAwesomeIcon icon={feedbackIcon ? feedbackIcon : FontAwesomeIcons.Solid.BAN} fixedWidth />
            </span> :
            null;


        const feedback = (invalid && !disabled) && !hasHardError ?
            <span className={classNames("form-control-feedback pr-2")}>
                <FontAwesomeIcon icon={feedbackIcon ? feedbackIcon : FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE} fixedWidth />
            </span> :
            null;

        const softFeedback = hasSoftError && !disabled && (!invalid) ? 
            <span className={classNames("form-control-feedback warning pr-2")}>
                <FontAwesomeIcon icon={feedbackIcon ? feedbackIcon : FontAwesomeIcons.Solid.EXCLAMATION_TRIANGLE} fixedWidth />
            </span> :
            null;


        if (addOnLeft || addOnRight || addOnRightButton) {
            return <div className={classNames(
                derivedAddonClass,
                "input-group"
            )}>
                {
                    addOnLeft ?
                        <div onClick={onFocus} className="input-group-prepend" id={id + "-addon-left"}>
                            <span className="input-group-text">
                                {addOnLeft}
                            </span>

                        </div> :
                        null
                }
                {textInput}
                <div style={{ position: "relative" }}>
                    {hardFeedback}
                    {feedback}
                    {softFeedback}
                </div>
                {
                    addOnRight ?
                        <div onClick={onFocus} className="input-group-append" id={id + "-addon-right"}>
                            <span className="input-group-text">
                                {addOnRight}
                            </span>

                        </div> :
                        null
                }
                {
                    addOnRightButton ?
                        <div onClick={onFocus} className="input-group-append" id={id + "-addon-right"}>
                            {addOnRightButton}
                        </div> :
                        null
                }
            </div>
        }

        return <div style={{ position: "relative" }}>
            {textInput}
            {hardFeedback}
            {feedback}
            {softFeedback}
        </div>
    }
}

export default SuggestionFormInput;